// eslint-disable-next-line no-unused-vars
import React, { PureComponent } from 'react';
class ErrorBoundary extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false
    };
  }
  static getDerivedStateFromError() {
    // Update state so the next render will show the fallback UI.
    return {
      hasError: true
    };
  }
  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.warn('Error: ', error, '\n detailed information (optional): \n', info);
  }
  render() {
    if (this.state.hasError) {
      return null;
    }
    return this.props.children;
  }
}
export default ErrorBoundary;